import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

export interface IFocusScope extends ng.IScope {
        
}

@NgComponent({
    token: Token.KbFocus,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbFocus extends Directive {
    constructor(
        $timeout: ng.ITimeoutService
    ) {

        super();

        this.replace = true;
        this.restrict = "A";
        this.scope = false;
        this.link = (scope: IFocusScope, element: ng.IAugmentedJQuery, atts) => {
            $timeout(() => {
                element[0].focus();
            }, 200);
        };
            
    }

}
